module.exports = __webpack_public_path__ + "img/2.4a6c3400.png";